import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  TextField,
  Checkbox,
  FormHelperText,
  CircularProgress,
} from '@mui/material';
import { useState } from 'react';
import style from './styles.module.css';

export const InspectionFormDialog = ({ commune, open, handleClose, handleSubmit }) => {
  const [{ pool, velux, email }, setState] = useState({ pool: false, velux: false, email: '' });
  const [errors, setError] = useState({ email: false, types: false });
  const [isLoading, setLoading] = useState(false);
  const onFocus = () => setError({ email: false, types: false });

  const validateForm = () => {
    const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    let emailNotVerified = true;
    if (regex.test(email)) {
      emailNotVerified = false;
    }
    return { email: emailNotVerified, types: !pool && !velux };
  };

  const handleChange = e => {
    const { value, name, checked } = e.target;
    setState(last => ({ ...last, [name]: name === 'email' ? value : checked }));
  };

  const onSubmit = async () => {
    const isFormValid = validateForm();
    if (!isFormValid.email && !isFormValid.types) {
      const items = [];
      if (pool) {
        items.push('POOL');
      }
      if (velux) {
        items.push('VELUX');
      }
      setLoading(true);
      await handleSubmit(email, items);
      setLoading(false);
      handleClose();
    } else {
      setError(isFormValid);
    }
  };

  return (
    <Dialog open={open} p={1}>
      <DialogTitle>Lancer l'inspection</DialogTitle>
      <DialogContent>
        <DialogContentText>Êtes-vous sûr de vouloir lancer une inspection sur la commune de "{commune}" ?</DialogContentText>
        <DialogContentText my={2}>Veuillez saisir votre email ci-dessous, les résultats de l'inspection vous seront envoyer par mail.</DialogContentText>
        <FormControl error={errors.types} className={style.formControl}>
          <FormLabel>Type d'items à détecter :</FormLabel>
          <FormGroup className={style.typeFormGroup}>
            <FormControlLabel sx={{ width: '30%' }} control={<Checkbox checked={pool} onChange={handleChange} name='pool' />} label='Piscine' />
            <FormControlLabel sx={{ width: '30%' }} control={<Checkbox checked={velux} onChange={handleChange} name='velux' />} label='Velux' />
            {errors.types && <FormHelperText className={style.formTextHelper}>Veuillez sélectionner au moins un type d'item</FormHelperText>}
          </FormGroup>
        </FormControl>
        <TextField
          autoFocus
          name='email'
          label='Email Address'
          type='email'
          fullWidth
          variant='standard'
          onFocus={onFocus}
          onChange={handleChange}
          error={errors.email}
          helperText={errors.email && 'Veuillez enter une adresse email valide.'}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Annuler</Button>
        <Button
          disabled={errors.email === true || errors.types === true || isLoading}
          startIcon={isLoading && <CircularProgress size='25px' />}
          onClick={onSubmit}
        >
          Continuer
        </Button>
      </DialogActions>
    </Dialog>
  );
};
